import React from "react";

const ContactInfo:React.FC = () => {
    return (<span className="text-muted">Contact Support @ +27 087 359 3241</span>);
}

export default ContactInfo;